import {CustomError} from './custom-error';

export class GeneralError extends CustomError {}
